import { render, staticRenderFns } from "./importDialog.vue?vue&type=template&id=854bb69c&lang=pug"
import script from "./importDialog.vue?vue&type=script&lang=js"
export * from "./importDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports